var Utils = require("./utils");
var queryArray = Utils.queryArray;
var form = document.querySelector("form.form");
var formId = form && form.id;
var guestBlocks = queryArray(".guest-block");
var guestField = document.getElementById("guest");
var dependentFields = queryArray("[data-dependent='true']");
var parentFields = [];

dependentFields.forEach(function (dependentField) {
  var parentId = dependentField.getAttribute("data-parent");
  parentFields.push(document.getElementById(parentId));
});
parentFields.forEach(function(parentField){
  parentField.addEventListener("change", function() {
    var dependentBlock = document.querySelector("[data-dependent='true'][data-parent='" + parentField.id + "']");
    var dependentFields = queryArray("input, select, textarea", dependentBlock);

    if (parentField && parentField.checked) {
      dependentBlock.classList.remove("hidden");
      dependentFields.forEach(function (field) {
        field.classList.remove("hidden");
      });
    } else {
      dependentFields.forEach(function (field) {
        dependentBlock.classList.add("hidden");
        field.classList.add("hidden");
      });
    }
  });
});


if (formId == "registration") {
  guestBlocks.forEach(function (block) {
    block.classList.add("hidden");
  });

  guestField.addEventListener("change", function () {
    if (guestField && guestField.checked) {
      guestBlocks.forEach(function (block) {
        block.classList.remove("hidden");
      });
    } else {
      guestBlocks.forEach(function (block) {
        block.classList.add("hidden");
      });
    }
  });
}

function guestFieldFilter(requiredFields) {
  if (guestField && !guestField.checked) {
    var guestFields = queryArray(".guest-block [required]");
    return requiredFields.filter(function (reqField) {
      return guestFields.indexOf(reqField) === -1;
    });
  }
  return requiredFields;
}

function submitRegistrationForm(formFields, formId, formAlert) {
  return formHelpers
    .createFormData(formFields, formId)
    .then(function (formData) {
      return window.fetch(
        location.pathname.replace(/\/+$/g, "") + "/checkout",
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
    })
    .then(function (response) {
      if (response.ok) {
        return response.json().then(function (data) {
          window.stripe.redirectToCheckout({
            sessionId: data.sessionId,
          });
        });
      } else {
        formAlert.innerHTML =
          "There was an issue processing this registration. Please contact us directly for more assistance.";
        document.querySelector("form.form").scrollIntoView();
        nextBtn.innerHTML = "Submit";
        nextBtn.disabled = false;
      }
    });
}

window.registrationFormHelpers = {
  submitRegistrationForm: submitRegistrationForm,
  guestFieldFilter: guestFieldFilter,
};
